import React, { FunctionComponent } from "react";
import { Box, Typography } from "@mui/material";
import { format } from "date-fns";
import { ChatMessage, ChatMessageAuthor } from "../../context/ChatContext";
import { grayscaleText, whiteText } from "../../styles/theme";
import MarkdownText from "./MarkdownText";

interface ChatMessageBubbleProps {
	message: ChatMessage;
	showTimestamp?: boolean;
}

const ChatMessageBubble: FunctionComponent<ChatMessageBubbleProps> = ({
	message,
	showTimestamp,
}) => {
	const isBot = message.author === ChatMessageAuthor.BOT;
	return (
		<Box
			sx={{
				alignSelf: isBot ? "flex-start" : "flex-end",
				display: "flex",
				flexDirection: "column",
				alignItems: isBot ? "flex-start" : "flex-end",
				maxWidth: "85%",
			}}
		>
			<Box
				sx={{
					padding: "10px 14px",
					borderRadius: isBot ? "12px 12px 12px 2px" : "12px 12px 2px 12px",
					backgroundColor: isBot ? "white" : grayscaleText,
					color: message.isError
						? "#D54753"
						: isBot
						? grayscaleText
						: whiteText,
				}}
			>
				{message.isMarkdown ? (
					<MarkdownText text={message.text} />
				) : (
					<Typography
						variant="body2"
						sx={{ color: "inherit", whiteSpace: "pre-wrap" }}
					>
						{message.text}
					</Typography>
				)}
			</Box>
			{showTimestamp && (
				<Typography variant="caption" sx={{ marginTop: "4px" }}>
					{format(message.timestamp, "HH:mm")}
				</Typography>
			)}
		</Box>
	);
};

export default ChatMessageBubble;
